<div class="skip-to-content-body">
  <a
    routerLink="./"
    *ngIf="mainContentID"
    class="btn btn-primary btn-sm text-nowrap"
    fragment="{{ mainContentID }}"
    >{{ mainContentButtonLabel }}</a
  >
  <a
    routerLink="./"
    *ngIf="secondContentID && secondContentButtonLabel"
    class="btn btn-primary btn-sm text-nowrap"
    fragment="{{ secondContentID }}"
    >{{ secondContentButtonLabel }}</a
  >
  <a
    routerLink="./"
    *ngIf="thirdContentID && thirdContentButtonLabel"
    class="btn btn-primary btn-sm text-nowrap"
    fragment="{{ thirdContentID }}"
    >{{ thirdContentButtonLabel }}</a
  >
</div>
